module.exports = __webpack_public_path__ + "img/mail_black.de761993.svg";